import { apiDocInstance } from "src/configs/axios.config";
import { axiosHandler } from "src/helpers/axios.helper";

const v1 = "/v1/master";

export const fetchAddresses = () =>
    axiosHandler<AddressesRespones>(apiDocInstance.get(`${v1}/address`));
